import { useEffect, useState } from "react";
import { useCall } from "@usedapp/core";
import { Contract } from "@ethersproject/contracts";
import AirdropDistributor from "@/chain-info/contracts/AirdropDistributor.json";
import { constants, utils } from "ethers";

const useClaimed = (
  airdropAddr: string | undefined,
  claimAccount: string | undefined | null,
  expectedChainId: number | undefined
) => {
  const [error, setError] = useState<string | undefined>();
  const [claimed, setClaimed] = useState<any>();
  const [loading, setLoading] = useState(false);
  const { abi } = AirdropDistributor;
  const airdropDistributorInterface = new utils.Interface(abi);
  const airdropDistributorContract = new Contract(
    airdropAddr ?? constants.AddressZero,
    airdropDistributorInterface
  );

  const { value, error: callError } =
    useCall(
      // @ts-ignore
      claimAccount && {
        contract: airdropDistributorContract,
        method: "claimed",
        args: [claimAccount],
      },
      { chainId: expectedChainId }
    ) ?? {};
  if (callError) {
    console.error(callError.message);
  }

  useEffect(() => {
    setLoading(true);
    if (value) {
      setClaimed(value?.[0]);
      setLoading(false);
    }
    if (callError) {
      setError(callError.message);
      setLoading(false);
    }
  }, [callError, value]);

  return { claimed, error, loading };
};

export default useClaimed;
